export enum MapMode {
    OPERATION = 1,
    VIEW = 2
}